export const env = {
  urlDemo: process.env.REACT_APP_URL_DEMO_INVENTORIES,
};
